/* istanbul ignore file */

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'

import TemplateListItem from './TemplateListItem/TemplateListItem'
import * as Styles from './styles'

const SortableTemplateItem = props => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props?.data?.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Styles.SortableTemplateItemContainer dragging={props.dragging} ref={setNodeRef} style={style}>
      <DotsSixVerticalIcon size={24} id="draggable-icon" data-testid="draggable-icon" {...attributes} {...listeners} />
      <TemplateListItem {...props} index={props.position} />
    </Styles.SortableTemplateItemContainer>
  )
}

export default SortableTemplateItem
